/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Themes } from '@app/core/types';
import { createAction, props } from '@ngrx/store';
import { DurationInMs } from '@shared/types/snapshots';

export const toggleTheme = createAction('[Theme] Toggle theme');
export const setTheme = createAction('[Theme] Set theme', props<{ theme: Themes }>());
export const changeThemeAccordingToOS = createAction(
  '[Theme] Change theme according to OS preferences',
  props<{ theme: Themes }>(),
);

export const setErrorSnackbarDuration = createAction(
  'Set error snackbar duration',
  props<{ duration: DurationInMs }>(),
);

export const setSnackbarDuration = createAction('Set snackbar duration', props<{ duration: DurationInMs }>());
